'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _companyAddForm = require('./company-add-form.html');

var _companyAddForm2 = _interopRequireDefault(_companyAddForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _companyAddForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    company: '<',
    onCompanyChanged: '&'
  },
  controller: function () {
    function CompanyAddFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, CompanyAddFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(CompanyAddFormComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.onCompanyChanged(this.EventEmitter({
          company: this.company
        }));
      }
    }]);

    return CompanyAddFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/company/company-add-form/company-add-form.component.js